import { Skeleton } from '@/components/ui/skeleton';
import { Card, CardContent, CardHeader } from '@/components/ui/card';

interface ExceptionLoadingStateProps {
  viewMode: 'card' | 'list';
  count?: number;
}

export function ExceptionLoadingState({ viewMode, count = 6 }: Readonly<ExceptionLoadingStateProps>) {
  if (viewMode === 'card') {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {Array.from({ length: count }).map((_, index) => (
          <Card key={`skeleton-card-${index}`}>
            <CardHeader className="space-y-2">
              <div className="flex items-center justify-between">
                <Skeleton className="h-5 w-24" />
                <Skeleton className="h-5 w-16" />
              </div>
              <Skeleton className="h-4 w-32" />
            </CardHeader>
            <CardContent className="space-y-3">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-3/4" />
              <div className="flex items-center gap-2 pt-2">
                <Skeleton className="h-6 w-20" />
                <Skeleton className="h-6 w-20" />
              </div>
              <div className="flex items-center gap-2 pt-2">
                <Skeleton className="h-8 w-8 rounded-full" />
                <div className="flex-1">
                  <Skeleton className="h-3 w-24 mb-1" />
                  <Skeleton className="h-3 w-32" />
                </div>
              </div>
              <Skeleton className="h-9 w-full mt-4" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="border rounded-lg">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50">
            <tr>
              <th className="p-3 text-left">
                <Skeleton className="h-4 w-4" />
              </th>
              <th className="p-3 text-left">
                <Skeleton className="h-4 w-16" />
              </th>
              <th className="p-3 text-left">
                <Skeleton className="h-4 w-24" />
              </th>
              <th className="p-3 text-left">
                <Skeleton className="h-4 w-20" />
              </th>
              <th className="p-3 text-left">
                <Skeleton className="h-4 w-20" />
              </th>
              <th className="p-3 text-left">
                <Skeleton className="h-4 w-16" />
              </th>
              <th className="p-3 text-left">
                <Skeleton className="h-4 w-16" />
              </th>
              <th className="p-3 text-left">
                <Skeleton className="h-4 w-24" />
              </th>
              <th className="p-3 text-left">
                <Skeleton className="h-4 w-16" />
              </th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: count }).map((_, index) => (
              <tr key={`skeleton-row-${index}`} className="border-t">
                <td className="p-3">
                  <Skeleton className="h-4 w-4" />
                </td>
                <td className="p-3">
                  <Skeleton className="h-5 w-16" />
                </td>
                <td className="p-3">
                  <Skeleton className="h-4 w-32" />
                </td>
                <td className="p-3">
                  <Skeleton className="h-4 w-24" />
                </td>
                <td className="p-3">
                  <Skeleton className="h-4 w-20" />
                </td>
                <td className="p-3">
                  <Skeleton className="h-5 w-16" />
                </td>
                <td className="p-3">
                  <Skeleton className="h-5 w-16" />
                </td>
                <td className="p-3">
                  <Skeleton className="h-4 w-28" />
                </td>
                <td className="p-3">
                  <Skeleton className="h-8 w-20" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
